/**
 * List of all user feature flags, see documentation in Confluence:
 * https://workpathhq.atlassian.net/wiki/x/IwDYsAE
 *
 * Please keep this list in sync with the documentation - and vice versa!
 */
import { ElementOf } from 'types/utilityTypes';

export const allUserFeatureFlags = [
  'aiConversationStarter',
  'auditLogExport',
  'azure_devops',
  'conversations',
  'disable_child_issue_tracking',
  'modifyBuMembers',
  'kr_automation',
  'mcp_setting',
  'kpi_time_frame',
  'entity_search_filters',
  'conversations3000',
  'collaborativeTextWidget',
  'jira_flipped',
  'jira_org_unit_projects',
  'initiative_history',
  'key_result_history',
  'goal_history',
] as const;

export type UserFeatureFlagName = ElementOf<typeof allUserFeatureFlags>;

export type UserFeatureFlags = UserFeatureFlagName[];
